import { DatePicker, Modal, Table } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
// import Column from 'antd/lib/table/Column';

const { Column } = Table;

class ShowEprescriptionsModal extends Component {
  onDateChange = (record, dateString) => {
    axios({
      method: "put",
      url: `/prescription_medicines/${record.id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        prescription_medicine: {
          expiry_date: dateString,
        },
      },
    }).then(() => {
      // console.log(response);
    });
  };

  disabledDate = (current) => current && current < moment().add(6, "months");

  render() {
    const { visible, onCancel, data } = this.props;

    return (
      <div>
        <Modal
          visible={visible}
          style={{ textAlign: "center", top: 20 }}
          width="75%"
          title="All Medicines"
          onCancel={onCancel}
          footer={null}
          key="id"
        >
          <div style={{ height: "580px", overflow: "auto" }}>
            <Table
              dataSource={data}
              pagination={false}
              scroll={{ x: 2200 }}
              size="middle"
              rowKey="id"
              style={{ overflow: "wrap" }}
            >
              <Column
                title="# med"
                width={75}
                fixed="left"
                align="center"
                render={(record) => data.indexOf(record) + 1}
              />
              <Column
                title="Name"
                dataIndex="name"
                key="name"
                width={200}
                fixed="left"
                align="center"
              />
              <Column
                style={{ wordBreak: "keep-all" }}
                title="DQ"
                dataIndex="quantity"
                key="quantity"
                width={50}
                align="center"
              />
              <Column
                title="Form"
                dataIndex="form"
                key="form"
                width={100}
                align="center"
              />
              <Column
                title="Start"
                dataIndex="start_date"
                key="start_date"
                width={150}
                align="center"
              />
              <Column
                title="End"
                // dataIndex="end_date"
                render={(record) =>
                  moment(record.end_date).isValid() ? record.end_date : "–"
                }
                key="end_date"
                width={150}
                align="center"
              />
              <Column
                title="Duration(days)"
                render={(record) => {
                  const start = moment(record.start_date);
                  const end = moment(record.end_date);
                  return (
                    <p>
                      {isNaN(end.diff(start, "days") + 1)
                        ? "–"
                        : end.diff(start, "days") + 1}
                    </p>
                  );
                }}
                width={150}
                align="center"
              />
              <Column
                title="DD"
                dataIndex="dosage_direction"
                key="dosage_direction"
                width={150}
                align="center"
              />
              <Column
                title="T1"
                dataIndex="time_1"
                key="time_1"
                align="center"
                width={100}
                style={{ wordBreak: "break-word" }}
              />
              <Column
                title="D1"
                dataIndex="direction_1"
                key="direction_1"
                align="center"
                width={100}
                style={{
                  wordBreak: "break-word",
                  overflow: "wrap",
                  whiteSpace: "unset",
                }}
              />
              <Column
                title="T2"
                dataIndex="time_2"
                key="time_2"
                width={100}
                align="center"
              />
              <Column
                title="D2"
                dataIndex="direction_2"
                key="direction_2"
                width={100}
                align="center"
              />
              <Column
                title="T3"
                dataIndex="time_3"
                key="time_3"
                width={100}
                align="center"
              />
              <Column
                title="D3"
                dataIndex="direction_3"
                width={100}
                key="direction_3"
                align="center"
              />
              <Column
                title="T4"
                dataIndex="time_4"
                width={100}
                key="time_4"
                align="center"
              />
              <Column
                title="D4"
                dataIndex="direction_4"
                width={100}
                key="direction_4"
                align="center"
              />
              <Column
                title="Freq"
                dataIndex="frequency"
                width={50}
                key="frequency"
                align="center"
              />
              <Column
                title="M D"
                dataIndex="month_days"
                key="month_days"
                width={100}
                align="center"
              />
              <Column
                title="W D"
                dataIndex="week_days"
                key="week_days"
                width={100}
                align="center"
              />
              {/* <Column
                                title="Expiry date"
                                key="id"
                                width={150}
                                dataIndex="expiry_date"
                            /> */}
              {/* <Column
                title="Expiry date"
                key="id"
                width={150}
                render={(record) => (
                  <DatePicker
                    // placeholder = {record.expiry_date !== null ? moment(record.expiry_date) : 'select date'}
                    defaultValue={
                      record.expiry_date !== null
                        ? moment(record.expiry_date)
                        : null
                    }
                    onChange={(date, dateString) =>
                      this.onDateChange(record, dateString)
                    }
                  />
                )}
              /> */}

              <Column
                title="Expiry date"
                key="id"
                width={150}
                render={(record) => (
                  <DatePicker
                    defaultValue={
                      record.expiry_date !== null
                        ? moment(record.expiry_date)
                        : null
                    }
                    onChange={(date, dateString) => this.onDateChange(record, dateString)}
                    // disabledDate={(current) => current && current < moment().endOf('day') && current < moment().endOf('month')}
                    disabledDate={(current) => {
                      const oneMonthFromNow = moment().add(1, 'month').startOf('day');
                      return current && (current < moment().endOf('day') || current < oneMonthFromNow);
                    }}
                  />
                )}
              />
            </Table>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ShowEprescriptionsModal;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/ShowEprescriptionsModal.js